import { Navigate, useLocation } from "react-router-dom";

/**
 * Client-side redirect map for legacy URLs that Google has indexed.
 * Lovable hosting ignores public/_redirects, so we handle them in-app.
 * Using <Navigate replace> signals a permanent redirect to crawlers.
 */

const EXACT_REDIRECTS: Record<string, string> = {
  "/cookie-policy": "/cookies",
  "/everyday": "/shop?search=everyday",
  "/prayer": "/prayer-wear",
  "/browse": "/shop",
  // /fragrance and /occasion are now real category routes — no redirect.
};

const PREFIX_REDIRECTS: { prefix: string; target: string }[] = [
  { prefix: "/products", target: "/shop" },
  { prefix: "/en/", target: "/" },
  { prefix: "/de/", target: "/" },
];

const LegacyRedirects = () => {
  const { pathname, search } = useLocation();
  const lower = pathname.toLowerCase();

  // Exact match
  const exact = EXACT_REDIRECTS[lower];
  if (exact) return <Navigate to={exact} replace />;

  // Prefix match — /products preserves query params
  for (const { prefix, target } of PREFIX_REDIRECTS) {
    if (lower === prefix || lower.startsWith(prefix + "/") || lower.startsWith(prefix + "?")) {
      const dest = target + (search || "");
      return <Navigate to={dest} replace />;
    }
  }

  return null;
};

export default LegacyRedirects;
